import "@/App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { QuoteProvider } from "@/context/QuoteContext";
import LandingPage from "@/pages/LandingPage";
import QuoteDialog from "@/components/landing/QuoteDialog";

function App() {
  return (
    <div className="App">
      <QuoteProvider>
        <HashRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
          </Routes>
          <QuoteDialog />
        </HashRouter>
        <Toaster position="top-center" richColors closeButton />
      </QuoteProvider>
    </div>
  );
}

export default App;
